import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginFooterModule } from '../../shared/login-footer/login-footer.module';
import { LoginHeaderModule } from '../../shared/login-header/login-header.module';
import { LogoHeaderModule } from '../../shared/logo-header/logo-header.module';
import { RecoverBySecurityQuestionsComponent } from './recover-by-security-questions.component';
import {
  AlertWarningModule,
  ButtonModule,
  CheckboxStandardModule,
  FormAlertModule,
  HelpIconModule,
  InputModule
} from '@com-delta-idp/mnx-ui-kit';

@NgModule({
  declarations: [RecoverBySecurityQuestionsComponent],
  imports: [
    CommonModule,
    LoginFooterModule,
    LogoHeaderModule,
    LoginHeaderModule,
    InputModule,
    CheckboxStandardModule,
    HelpIconModule,
    ButtonModule,
    ReactiveFormsModule,
    AlertWarningModule,
    FormAlertModule
  ],
  exports: [RecoverBySecurityQuestionsComponent]
})
export class RecoverBySecurityQuestionsModule {}
